import React from "react";
import { Col, Button } from "reactstrap";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import signupGoals from "../../../assets/img/custom/signupGoals.jpg";
import athleteRecruitNotice from "../../../assets/img/custom/athleteRecruitNotice.jpg";
import fhpCoinImage from "../../../assets/img/custom/fhpCoinImage.jpg";
import HSImage from "../../../assets/img/custom/HSImage.avif";
import coinInfoImage from "assets/img/custom/coin-info.png";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

export default function HomeLeftCol({
  allUrls,
  handleDownload,
  handleDownloadEcosystemPdf,
  toggleFhpCoinModal,
  toggleFhpCoinVideo,
  toggleCoinInfo,
  coinInfoOpen,
}) {
  return (
    <Col lg="4" className="text-center mt-5">
      {allUrls?.map((item, index) => (
        <div
          className="d-flex flex-cloumn justify-content-start mt-1"
          key={index}
        >
          <div>
            <Button
              size="sm"
              className="bg-dark mr-2 text-white"
              onClick={() => {
                copy(item?.copyLink);
                toast.success("Link Copied");
              }}
            >
              Copy
            </Button>
          </div>
          <a href={item?.copyLink} target="_blank" rel="noopener noreferrer">
            {item?.link}
          </a>
        </div>
      ))}

      <div className="text-center text-lg-left mt-2">
        <h2 className="font-weight-bold">
          <b>Help videos go viral, so players benefit</b>
        </h2>
      </div>

      <div className="d-flex justify-content-center m-5">
        <img src={signupGoals} alt="SignUp Goals" />
      </div>

      <div className="mb-3 text-center">
        <a
          className="bg-primary text-white border-0 rounded p-3"
          style={{ cursor: "pointer" }}
          href="https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/NIL_Platform_Disclaimer.pdf?alt=media&token=64f46808-29e0-4d42-beb6-f14e828c928f"
          target="_blank"
          rel="noopener noreferrer"
        >
          IMPORTANT MUST READ
        </a>
      </div>

      <div className="d-flex justify-content-center m-5">
        <img src={athleteRecruitNotice} alt="Notice" />
      </div>  

      <img src={HSImage} className="w-100" alt="" />
    </Col>
  );
}
